import { Component, computed, inject, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatService } from '../../../../../services/chat/chat.service';
import { VoiceService } from '../../../../../services/voice/voice.service';

interface LobbyUser {
  status: 'online' | 'away' | 'ingame';
  isReady: boolean;
  role: 'member' | 'admin';
  userName: string;
  userNameSlug: string;
}

interface Arena {
  id: number;
  lobbyId: number;
  name: string;
  status: 'open' | 'locked' | 'ingame';
  participants: LobbyUser[];
  maxPlayers: number;
}

@Component({
  selector: 'app-room-list',
  imports: [CommonModule],
  templateUrl: './room-list.html',
  styleUrl: './room-list.scss',
})
export class RoomList {
  @Input() isMobile: boolean = false;

  private chatService = inject(ChatService);
  private voiceService = inject(VoiceService);

  public arena = this.chatService.arena;
  public rooms = this.chatService.rooms;
  public isGameInstalled = this.chatService.isCurrentGameInstalled;

  public selectedLobbyId = signal<number>(1);
  public selectedArenaId = signal<string | null>(null);
  public largeImageArenas = signal<Record<string, boolean>>({});

  public onImageLoad(event: Event, guid: string) {
    const img = event.target as HTMLImageElement;
    const isWide = img.naturalWidth / img.naturalHeight > 1.2;
    const isTall = img.naturalHeight / img.naturalWidth > 1.2;
    const isLarge = img.naturalWidth > 64 || img.naturalHeight > 64;

    if (isWide || isTall || isLarge) {
      this.largeImageArenas.update(prev => ({ ...prev, [guid]: true }));
    }
  }

  public currentUser = signal<any>({
    name: 'Elektrophunk',
    avatar: 'https://static.h5arena.com/images/avatars/Premium/180.jpg'
  });

  public filteredArenas = computed(() => this.rooms().filter(a => a.lobbyId === this.selectedLobbyId()));

  public join(arenaId: string) {
    const targetRoom = this.rooms().find(r => r.guid === arenaId);
    if (targetRoom && (targetRoom.status === 'locked' || targetRoom.isProtected)) {
      this.chatService.targetLockedArena.set(targetRoom);
      const modalEl = document.getElementById('passwordModal');
      if (modalEl) {
        const modal = new (window as any).bootstrap.Modal(modalEl);
        modal.show();
      }
      return;
    }
    this.voiceService.disconnect();
    this.chatService.join(arenaId, "");
  }

  public selectLobby(lobbyId: number) {
    this.selectedLobbyId.set(lobbyId);
    const firstArenaOfLobby = this.filteredArenas()[0];
    if (firstArenaOfLobby) {
      this.selectArena(firstArenaOfLobby.guid);
    }
  }

  public selectArena(arenaId: string) {
    this.selectedArenaId.set(arenaId);
  }

  public getArenaStatusInfo(status: Arena['status']) {
    switch (status) {
      case 'open': return { icon: 'bi-unlock-fill', color: 'text-success' };
      case 'locked': return { icon: 'bi-lock-fill', color: 'text-warning' };
      case 'ingame': return { icon: 'bi-swords', color: 'text-danger' };
    }
  }
}
